import React, { Fragment, useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";

//Material-UI Core Components
import { CircularProgress, Typography, Box } from "@mui/material";

//Material-UI Icons
import EditIcon from "@mui/icons-material/Edit";

//Custom Components
import MapCard from "@/ui/MapCard/MapCard";
import MapCardHeader from "@/ui/MapCard/MapCardHeader";
import MapCardAvatar from "@/ui/MapCard/MapCardAvatar";
import MapCardContent from "@/ui/MapCard/MapCardContent";
import MapCardActions from "@/ui/MapCard/MapCardActions";
import MapCardActionButton from "@/ui/MapCard/MapCardActionButton";
import dataController from "@/lib/dataController";
import MapCardHeaderButtonClose from "@/ui/MapCard/MapCardHeaderButtonClose";
import DialogContext from "@/ui/DialogContext/DialogContext";
import { GridContainer, GridItem } from "@/ui/Grid";
import FormContent from "@/components/FormContent";
import modelComments from "@/models/komentari"
import CommentDialog from "./CommentDialog"
import ImageSlider from "./ImageSlider"
import CommentIcon from '@mui/icons-material/SpeakerNotesOutlined';
import { } from "@mui/material";


//Types
import { CommentInfoCardProps } from "@/@types/views/GIS/map";
import { DCRecord } from "@/@types/lib/dataController";
import UserContext from "@/components/UserContext/UserContext";
import { Permissions } from "@/lib/permissions";


function CommentInfoCard(props: CommentInfoCardProps) {
  const { t } = useTranslation();

  const [loadStatus, setLoadStatus] = useState({ isLoading: true, isLoaded: false });
  const [comment, setComment] = useState<any>(null);

  const dialogContext = useContext(DialogContext);
  const userContext = useContext(UserContext)

  const dc = new dataController(modelComments);

  const { featureData, onClose, onDelete, refreshLayers, refreshPhotos } = props;

  const refreshComment = () => {
    // @ts-ignore 
    setLoadStatus({ isLoading: true, isLoaded: false });
    dc.GetDataSingle(Number(featureData.feature.getId())).then((resp) => {
      if (resp && resp.data) {
        setComment(resp.data)
      } else {
        // setComments(null)
      }
    })
      .finally(() => {
        setLoadStatus({ isLoading: false, isLoaded: true });
      })
  }

  useEffect(() => {
    refreshComment();
  }, [featureData]);


  const handleCommentDialogClose = (result: any) => {
    if (result.dataChanged && result.action !== "delete") {
      if (refreshPhotos && featureData.record && featureData.record.length !== 0) {
        refreshPhotos(featureData.feature, undefined, featureData.position);
      } else {
        refreshComment();
      }
    } else if (result.action == "delete") {
      if (onDelete) {
        onDelete()
      }
      onClose()
    } else {
      if (refreshPhotos && featureData.record && featureData.record.length !== 0) {
        refreshPhotos(featureData.feature, undefined, featureData.position);
      }
    }
  };

  const handleEditComment = () => {
    if (userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod])) {
      dialogContext.showDialog(CommentDialog, {
        dc: dc,
        mode: "update",
        form: userContext?.hasAnyPermission([Permissions.HGSSMod]) ? "update-hgss"
          : userContext?.hasAnyPermission([Permissions.HPSMod]) ? "update-hps"
            : "default",
        recordId: undefined,
        onClose: handleCommentDialogClose,
        feature: featureData.feature,
        refreshLayers: () => {
          if (refreshPhotos) {
            refreshPhotos(featureData.feature, undefined, featureData.position);
          } else {
            refreshComment();
          }
        },
        // @ts-ignore
        initialRecord: {
          photos: featureData.record && Array.isArray(featureData.record) && featureData.record?.length !== 0 ?
            featureData?.record : {},
          ...comment
        }
      });
    }
  };

  const form = "default";

  return (
    <MapCard
      sx={{
        backgroundColor: "background.default",
        minWidth: "200px",
      }}
    >
      {
        loadStatus.isLoaded ?
          <>
            <MapCardHeader
              title={comment?.created_by}
              subheader={t("common.id") + ": " + comment?.id}
              subheaderTypographyProps={{ color: "initial" }}
              avatar={<CommentIcon sx={{ color: "#FFF" }} fontSize="large" />}
              action={<MapCardHeaderButtonClose onClick={onClose} />}
            />
            <MapCardContent >
              <Box display={"flex"} flexDirection={"column"} m={1}>
                <Box width={"100%"}>
                  {featureData.record && featureData.record !== null && Array.isArray(featureData.record) ? (
                    <ImageSlider images={featureData.record.map(rec => rec.image)} />
                  ) : (
                    <ImageSlider images={[]} />
                  )}
                </Box>
                <Box width={"100%"} py={0.75} px={2} minHeight={"75px"}>
                  {comment && comment.komentar !== null ? (
                    <Typography sx={{ textAlign: 'left', wordWrap: 'break-word' }} variant="body2" fontFamily={"Roboto"}
                    >{comment.komentar}</Typography>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>

            </MapCardContent>
            <MapCardActions
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                alignItems: "center",
                flexWrap: "wrap",
                marginTop: "0px",
                marginBottom: "5px",
                overflow: "hidden"
              }}
            >
              {
                userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod]) ?
                  <MapCardActionButton startIcon={<EditIcon />} onClick={handleEditComment}>
                    {t("buttons.edit_comment")}
                  </MapCardActionButton> : <></>
              }
            </MapCardActions>
          </>
          :
          <CircularProgress />
      }
    </MapCard>
  );
}

export default CommentInfoCard;
